import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Text } from "@chakra-ui/react";
const TabLayout = ({ tabs, selectedTab, onTabChange, width = "100%", selectedColor = "white", selectedBg = "#1F1F1F", solidSlider = false, size = "md", }) => {
    const availableTabs = tabs;
    const selectedIndex = availableTabs.findIndex((tab) => tab.name === selectedTab);
    // Size-based configuration
    const sizeConfig = {
        sm: {
            containerPadding: 0.5,
            tabPadding: { base: 1, md: 1 },
            fontSize: "10px",
            gap: 1,
            minWidth: "80px",
        },
        md: {
            containerPadding: 1,
            tabPadding: { base: 2, md: 2 },
            fontSize: "xs",
            gap: 2,
            minWidth: "100px",
        },
        lg: {
            containerPadding: 1.5,
            tabPadding: { base: 3, md: 3 },
            fontSize: "sm",
            gap: 3,
            minWidth: "120px",
        },
    };
    const config = sizeConfig[size];
    return (_jsxs(Flex, { justify: "center", bg: "#1F1F1F", borderRadius: "50px", border: "2px solid #303030", boxSizing: "border-box", position: "relative", overflow: "hidden", width: width, p: config.containerPadding, children: [_jsx(Box, { position: "absolute", top: "0", left: "0", height: "100%", border: "1px solid", bg: solidSlider ? selectedBg : "transparent", borderColor: solidSlider ? selectedBg : selectedColor, borderRadius: "50px", transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)", style: {
                    width: `${100 / availableTabs.length}%`,
                    transform: `translateX(${selectedIndex * 100}%)`,
                } }), availableTabs.map((tab, index) => (_jsx(Box, { flexGrow: 1, cursor: "pointer", opacity: tab.isDisabled ? 0.5 : 1, onClick: () => {
                    if (tab.isDisabled) {
                        return;
                    }
                    else {
                        onTabChange(tab.name);
                    }
                }, position: "relative", textAlign: "center", py: config.tabPadding, minW: config.minWidth, zIndex: 1, transition: "all 0.3s ease-in-out", borderRadius: "50px", children: _jsxs(Flex, { justify: "center", align: "center", gap: config.gap, children: [selectedTab === tab.name ? tab.iconSelected : tab.icon, _jsx(Text, { color: selectedTab === tab.name ? selectedColor : "#9D9D9D", fontSize: config.fontSize, transition: "color 0.3s ease-in-out", fontWeight: selectedTab === tab.name ? "600" : "400", children: tab.label })] }) }, tab.name)))] }));
};
export default TabLayout;
